import { m } from "framer-motion";
import type { ReactNode } from "react";
import { fadeUp } from "../../lib/motion";

/**
 * One-shot fade-up on scroll into view. Below-the-fold children stay at
 * opacity 0 until seen — never wrap printable or emergency-critical content
 * (it can print invisible); use a mount-triggered `animate` variant instead
 * (see CaregiverView's SectionReveal).
 */
export function Reveal({
  children,
  delay = 0,
  className = "",
}: {
  children: ReactNode;
  delay?: number;
  className?: string;
}) {
  return (
    <m.div
      className={className}
      variants={fadeUp}
      custom={delay / 1000}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.12 }}
    >
      {children}
    </m.div>
  );
}
